/**
 * Calendar dates for form fields, in the browser's own time zone (SAST for the business).
 *
 * `date.toISOString().split('T')[0]` is the UTC date, not the local one. In SAST that is wrong
 * between 00:00 and 02:00 (it gives yesterday), and always wrong for a date built at local
 * midnight: `new Date(2026, 9, 0)` is 30 Sep 00:00 SAST = 29 Sep 22:00 UTC, so a "last day of
 * the month" came out as the day before it.
 */
const pad = (n: number): string => String(n).padStart(2, '0');

/** `YYYY-MM-DD` of `date` in local time. */
export const toLocalDateString = (date: Date = new Date()): string =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/** `YYYY-MM-DDTHH:mm` in local time - the value format of an `<input type="datetime-local">`. */
export const toLocalDateTimeInputValue = (date: Date = new Date()): string =>
  `${toLocalDateString(date)}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
